import * as React from 'react'
import { injectIntl, FormattedMessage, InjectedIntlProps } from 'react-intl'
import classNames from 'classnames'
import { autobind } from 'core-decorators'
import { IoIosChatboxes } from 'react-icons/io'
import { observer } from 'mobx-react'

import AppSelect from '../../shared/components/AppSelect'
import { IApplicationStore, IReviewStore } from '../../stores'
import GenevaButton from '../../shared/components/GenevaButton'
import './Header.scss'

interface IHeaderProps extends InjectedIntlProps {
  applicationStore: IApplicationStore,
  reviewStore: IReviewStore
}
interface IState {
  showMenu: boolean
}

@observer
class Header extends React.Component<IHeaderProps> {
  state: IState
  OS: string
  url: string
  dataurl: string
  mouseIsDownOnUserMenu: boolean


  constructor(props: IHeaderProps) {
    super(props)

    this.OS = (navigator.appVersion.indexOf('Mac') !== -1)
      ? 'MacOS'
      : 'WindowsOS'
  }

  componentWillMount(): void {
    this.setState({
      showMenu: false
    })
  }

  componentDidMount(): void {
    window.addEventListener('mouseup', this.pageClick, false)
  }

  componentWillUnmount(): void {
    window.removeEventListener('mouseup', this.pageClick)
  }

  @autobind
  pageClick(): void {
    if (this.mouseIsDownOnUserMenu) {

      this.setState({
        showMenu: !this.state.showMenu
      })
    }
    else {
      this.setState({
        showMenu: false
      })
    }

    this.mouseIsDownOnUserMenu = false
  }

  @autobind
  mouseDownHandler(): void {
    const { applicationStore, reviewStore } = this.props

    // check if backend needs to be notified
    if (!applicationStore.showSidebar && reviewStore.hiddenMessageCount) {
      applicationStore.updateLastVisted()
    }
    applicationStore.switchSideBarView()
  }

  @autobind
  exitScreenshotMode(): void {
    this.props.applicationStore.showScreenshotIndicatorView(false)
  }

  render() {
    const { applicationStore, reviewStore } = this.props

    const newMessageCount = reviewStore.hiddenMessageCount

    return (
      <div className="title_bar">
        <div className="logo">
          <div className={classNames('app_logo', this.OS)}>GENEVA</div>
        </div>

        <AppSelect
          current="rc"
          applicationStore={applicationStore}
          showDetails={false}
        />

        {applicationStore.showScreenshotIndicator
          ? <div className="screenshot-indicator">
            <label htmlFor="cancel-screenshot">
              <FormattedMessage id="review-center.screenshot.header-cancel" />
            </label>
            <GenevaButton
              id="cancel-screenshot"
              className="small button"
              onMouseDown={this.exitScreenshotMode}
            >
              <FormattedMessage id="button.abort" />
            </GenevaButton>
          </div>
          : null}

        <button
          className="sidebar-button"
          onMouseDown={this.mouseDownHandler}
        >
          <IoIosChatboxes
            size={30}
            color="#fff"
          />
          <div className={classNames('new-messages', { hidden: applicationStore.showSidebar || !newMessageCount })}>
            {newMessageCount}
          </div>
          {
            applicationStore.showSidebar
              ? <FormattedMessage
                id="sidebar-close"
              />
              : <FormattedMessage
                id="sidebar-open"
              />
          }
        </button>
      </div>
    )
  }
}

export default injectIntl(Header)
